import { useEffect, useState } from "react"
import { Button, Form, Spinner } from "react-bootstrap"
import Select from 'react-select'
import DataTable from "../../components/dataTable/DataTable"
import { createColumnHelper } from "@tanstack/react-table"
import dayjs from "dayjs"
import { ApiEndpoints, reqGetNew, reqPostNew } from "../../config/apiClient"
import { defineValueInInput, getValueFromInput } from "../../components/funcForInput"
import QrCodeModalDownloadRegistros from "./QrCodeModalDownloadRegistros"
import funcSleep from "../../components/funcSleep"

export default function QrCodesRegistrosPage() {

    useEffect(() => {
        document.title = "Registros Ronda | OB PORTUS"

        carregarFiltros()
        // eslint-disable-next-line
    }, [])

    const [loading, setLoading] = useState<boolean>(false)
    const [showModalDownload, setShowModalDownload] = useState<boolean>(false)
    const [filtroDados, setFiltroDados] = useState<any>({})
    const [dados, setDados] = useState<any[]>([])

    const [empresasFiltro, setEmpresasFiltro] = useState<any>([])
    const [empresasFiltroSelected, setEmpresasFiltroSelected] = useState<any>([])
    const [centrosCustoFiltro, setCentrosCustoFiltro] = useState<any[]>([])
    const [centrosCustoFiltroSelected, setCentrosCustoFiltroSelected] = useState<any[]>([])
    const [colaboradoresFiltro, setColaboradoresFiltro] = useState<any[]>([])
    const [colaboradoresFiltroSelected, setColaboradoresFiltroSelected] = useState<any[]>([])

    async function carregarFiltros() {
        const data_atual = dayjs()
        const data_inicial = data_atual.startOf('month').format("YYYY-MM-DD")
        const data_final = data_atual.endOf('month').format("YYYY-MM-DD")
        defineValueInInput('data_inicial', data_inicial)
        defineValueInInput('data_final', data_final)

        setLoading(true)
        const api = await reqGetNew(ApiEndpoints.qrcodeRegistrosFiltros)
        if (api.status === 200) {
            const dados = api.data
            let empresasAux = dados.empresas.map((item:any, index:any) => (
                {
                    "value": `${item.codigo}`,
                    "label": `${item.codigo} - ${item.nome}`
                }
            ))
            setEmpresasFiltro(empresasAux)
            let centrosAux = dados.centros_custo.map((item:any, index:any) => (
                {
                    "value": `${item.codigo}`,
                    "label": `${item.codigo} - ${item.centro_custo}`
                }
            ))
            setCentrosCustoFiltro(centrosAux)
            let colsAux = dados.colaboradores.map((item:any, index:any) => (
                {
                    "value": `${item.id_colaborador}`,
                    "label": `${item.matricula} - ${item.nome_completo}`
                }
            ))
            setColaboradoresFiltro(colsAux)
        }

        await listarRegistros()

        setLoading(false)
    }

    async function listarRegistros() {

        const filtro = {
            data_inicial: getValueFromInput("data_inicial"),
            data_final: getValueFromInput("data_final"),
            id_empresa: empresasFiltroSelected.map((item:any, index:any) => (Number(item.value))),
            id_centro_custo: centrosCustoFiltroSelected.map((item:any, index:any) => (Number(item.value))),
            id_colaborador: colaboradoresFiltroSelected.map((item:any, index:any) => (Number(item.value))),
        }

        setFiltroDados(filtro)

        setLoading(true)
        const api = await reqPostNew(ApiEndpoints.qrcodeRegistros, filtro)
        
        if (api.status === 200) {
            setDados(api.data)
            console.table(api.data)
        }
        
        setLoading(false)
    }

    async function handleShowModalDownload() {
        setLoading(true)
        const filtro = {
            data_inicial: getValueFromInput("data_inicial"),
            data_final: getValueFromInput("data_final"),
            id_empresa: empresasFiltroSelected.map((item:any, index:any) => (Number(item.value))),
            id_centro_custo: centrosCustoFiltroSelected.map((item:any, index:any) => (Number(item.value))),
            id_colaborador: colaboradoresFiltroSelected.map((item:any, index:any) => (Number(item.value))),
        }
        setFiltroDados(filtro)
        await funcSleep(500)
        setLoading(false)
        
        setShowModalDownload(true)
    }

    return (
        <div id="main">
            
            <h1 id="titleMain">Registros Ronda</h1>

            <QrCodeModalDownloadRegistros show={showModalDownload} handleClose={() => { setShowModalDownload(false) }} filtro={filtroDados} />

            <br></br>

            <div className="div-row">
                <Form.Control name='data_inicial' type="date" id='data_inicial' placeholder="Data Inicial" style={inputDatas} />
                <Form.Control name='data_final' type="date" id='data_final' placeholder="Data Final" style={inputDatas} />
                <Select name='ids_empresas' id='ids_empresas' options={empresasFiltro} defaultValue={empresasFiltroSelected} placeholder="Empresas" isMulti closeMenuOnSelect={false} onChange={
                    (choice) => {
                        setEmpresasFiltroSelected(choice)
                    }
                } styles={styleSelectEmpresas} />
                <Select name='ids_centro_custo' id='ids_centro_custo' options={centrosCustoFiltro} defaultValue={centrosCustoFiltroSelected} value={centrosCustoFiltroSelected} placeholder="Centros de Custo" isMulti closeMenuOnSelect={false} onChange={
                    (choice:any) => {
                        setCentrosCustoFiltroSelected(choice)
                    }
                } styles={styleSelectCentros} />
                <Select name='ids_colaboradores' id='ids_colaboradores' options={colaboradoresFiltro} defaultValue={colaboradoresFiltroSelected} value={colaboradoresFiltroSelected} placeholder="Colaboradores" isMulti closeMenuOnSelect={false} onChange={
                    (choice:any) => {
                        setColaboradoresFiltroSelected(choice)
                    }
                } styles={styleSelectCentros} />
                <Button onClick={() => { listarRegistros() }} variant='primary' style={{height: '40px'}} className='div-row-space-between'>Filtrar <span className="material-symbols-outlined">filter_alt</span></Button>
                <Button onClick={() => { handleShowModalDownload() }} variant='success' style={{height: '40px', marginLeft: "5px"}} className='div-row-space-between'>Relatório <span className="material-symbols-outlined" style={{marginLeft: "5px"}}>download_for_offline</span></Button>
            </div>

            <br></br>

            {loading && <Spinner />}
            {!loading && <DataTable dados={dados} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={() => {}} tableClickhandler={() => {}} defaultOrder={defaultOrder} defaultRows={23} />}

        </div>
    )
}

const columnHelper = createColumnHelper<any>()

const defaultColumns = [
    columnHelper.accessor(row => `${dayjs(row.data_criacao).format("DD/MM/YYYY HH:mm:ss")} #${row.id_scan}`, {
        header: 'Registro em',
        size: 300,
    }),
    columnHelper.accessor(row => `#${row.matricula} | ${row.nome_completo}`, {
        header: 'Colaborador',
        size: 500,
    }),
    columnHelper.accessor(row => `#${row.id_qrcode} | ${row.descricao}`, {
        header: 'QRCode',
        size: 500,
    }),
    columnHelper.accessor(row => `${row.internet} ${row.conexao} - ${row.modo_registro === "camera" ? "Scanner QRCODE" : "NFC TAG"}`, {
        header: 'Conexão',
        size: 300,
    }),
    columnHelper.accessor(row => `${row.latitude}, ${row.longitude}`, {
        header: 'Lat/Long',
        size: 300,
    }),
    columnHelper.accessor(row => row.obs, {
        header: 'Observação',
        size: 300,
    }),
]

const defaultOrder:any[] = []

const styleSelectEmpresas = {
    control: (baseStyles:any, state:any) => ({
        ...baseStyles,
        width: '250px',
        borderColor: "#dee2e6",
        minHeight: '39px',
        maxHeight: '120px',
        marginRight: '5px',
        fontSize: '14px'
    }),
    valueContainer: (provided:any, state:any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
        fontSize: '14px'
    }),
    input: (provided:any, state:any) => ({
        ...provided,
        margin: '0px',
        fontSize: '14px'
    }),
    indicatorSeparator: (state:any) => ({
        display: 'none',
        fontSize: '14px'
    }),
    indicatorsContainer: (provided:any, state:any) => ({
        ...provided,
        minHeight: '39px',
        maxHeight: '120px',
        fontSize: '14px'
    }),
    menu: (provided:any, state:any) => ({
        ...provided,
        fontSize: '14px'
    }),
}

const styleSelectCentros = {
    control: (baseStyles:any, state:any) => ({
        ...baseStyles,
        width: '400px',
        borderColor: "#dee2e6",
        minHeight: '39px',
        maxHeight: '120px',
        marginRight: '5px',
        fontSize: '14px'
    }),
    valueContainer: (provided:any, state:any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
        fontSize: '14px'
    }),
    input: (provided:any, state:any) => ({
        ...provided,
        margin: '0px',
        fontSize: '14px'
    }),
    indicatorSeparator: (state:any) => ({
        display: 'none',
        fontSize: '14px'
    }),
    indicatorsContainer: (provided:any, state:any) => ({
        ...provided,
        minHeight: '39px',
        maxHeight: '120px',
        fontSize: '14px'
    }),
    menu: (provided:any, state:any) => ({
        ...provided,
        fontSize: '14px'
    }),
}

const inputDatas:React.CSSProperties = {
    height: "41px",
    marginRight: "5px",
    maxWidth: "max-content"
}
